import { Box } from "@mui/material";
import frogLogo from "assets/images/frog-logo.svg";

const FrogLogo = ({ sx, ...props }) => (
  <Box
    component="img"
    src={frogLogo}
    alt="Frog"
    sx={{
      width: 210,
      height: 90,
      maxWidth: "100%",
      objectFit: "contain",
      display: "block",
      ...sx
    }}
    {...props}
  />
);

export default FrogLogo;
